import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Grid, Paper } from '@material-ui/core';
import MessageLogSearch from './MessageLogSearch';
import MessageLogTable from './MessageLogTable';
import MsgArea from './MessageLogMsgArea';
import { withCookies } from 'react-cookie';
import Pagination from '@material-ui/lab/Pagination';
import Common from '../Common';
import axios from 'axios';

const styles = () => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '95%',
        margin: '5px 5px 5px 50px',
        minWidth: 1400,
    },
    tableHeadColor: {
        backgroundColor: '#edeff0',
        borderColor: '#dee2e6',
        color: '#495057',
    },
    table: {
        minWidth: 1200,
    },
    cell: {
        display: 'block',
    },
    displayFlex: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    verticalSpaece: {
        margin: '20px 40px 20px 0px',
    },
    ttl: {
        fontSize: '28px',
        height: '45px',
    },
    content: {
        width: '90%',
    },
    content__mt: {
        marginTop: '15px',
    },
    buttonSpace: {
        position: 'fixed',
        right: '0',
        margin: '30px 250px',
    },
    paging: {
        marginTop: '20px',
        marginBottom: '20px'
    },
});

const displayNum = 20; //1ページあたりの項目数

const MessageLog = (props) => {
    const { classes, cookies } = props;
    const [userData, setUserData] = React.useState([]);
    const [fullTextDisplayData, setFullTextDisplayData] = React.useState([]);
    const [fullTextDisplayFlg, setFullTextDisplayFlg] = React.useState(false);
    const [page, setPage] = React.useState(1); //ページ番号
    const [pageCount, setPageCount] = React.useState(); //ページ数
    const [allItems, setAllItems] = React.useState([]); //全データ
    const [displayedItems, setDisplayedItems] = React.useState([]); //表示データ
    const [isLoading, setIsLoading] = React.useState(true);
    const scrollRef = useRef(null);
    //タブの名前を設定
    document.title = 'メッセージ送信履歴';
    const supportedPersonId = cookies.get('supportedPersonId');
    if (supportedPersonId === '' || supportedPersonId === undefined) {
        window.location.href = '/';
        return;
    }
    const availableAddress = cookies.get('AVAILABLE_ADDRESS') === 'TRUE' ? true : false;
    useEffect(() => {
        //検索時は1ページ目に戻る
        setPage(1);
        setAllItems(userData);
        //ページカウントの計算
        setPageCount(Math.ceil(userData.length / displayNum));
        //表示データを抽出
        setDisplayedItems(userData.slice(((page - 1) * displayNum), page * displayNum));
    }, [userData]);

    const handleChange = (event, index) => {
        //ページ移動時にページ番号を更新
        setPage(index);
        //ページ移動時に表示データを書き換える
        setDisplayedItems(allItems.slice(((index - 1) * displayNum), index * displayNum));
    };

    useEffect(() => {
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        const supportedPersonId = cookies.get('supportedPersonId');
        axios.post(
            `${Common.apiServerUrl()}/api/delivery/log`,
            {
                requestStartDate: '',
                requestEndDate: '',
                state: '',
                counselingKubunId: '',
                supportedPersonId: supportedPersonId,
                chatTitle: '',
                availableAddress,
                addressNumber: '',
                nickName: ''
            },
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
            }
        )
        .then(Common.handleErrors)
        .then((res) => {
            if (res.success) {
                if(res.result.length !== 0){
                    setUserData(res.result);
                }
            } else {
                window.alert(`code : [${res.type}]\nmessage : ${res.message}`);
            }
        })
        .catch((err) => {
            console.error('MessageLog.js :get err:' + err.message);
        })
        .finally(()=> {
            setIsLoading(false);
        });
    }, []);

    useEffect(() => {
        if(fullTextDisplayData.length !== 0){
            scrollToMsg(scrollRef);
        }
    }, [fullTextDisplayData]);

    const scrollToMsg = (ref) => {
        if (ref.current) {
            window.scrollTo({
                top: ref.current.offsetTop, // 要素の位置に基づいてスクロール
                behavior: 'smooth'
            });
        }
    };

    return (
        <React.Fragment>
            <Grid container justifyContent="center" direction="column">
                {/* <Grid > */}
                <Grid container item justifyContent="center" alignItems="center" className={classes.content + ' ' + classes.content__mt} xs={13}>
                    <Typography className={classes.ttl}>{'メッセージ送信履歴'}</Typography>
                </Grid>
                <Paper className={classes.paper} elevation={3}>
                    <div elevation={3} className={classes.paper} >
                        <MessageLogSearch
                            setData={setUserData}
                            setPage={setPage}
                            setFullTextDisplayFlg={setFullTextDisplayFlg}
                            availableAddress={availableAddress}
                            setIsLoading={setIsLoading}
                        />
                        <MessageLogTable
                            datas={displayedItems}
                            addressFlg={availableAddress}
                            setFullTextDisplayData={setFullTextDisplayData}
                            setFullTextDisplayFlg={setFullTextDisplayFlg}
                            isLoading={isLoading}
                        />
                        <Grid container item justifyContent="center" alignItems="center" className={classes.paging}>
                            <Pagination count={pageCount} page={page} size="large" color="primary" onChange={handleChange} />
                        </Grid>
                    </div>
                </Paper>
                { fullTextDisplayFlg && fullTextDisplayData.length !== 0 && (
                    <div ref={scrollRef}>
                        <Paper className={classes.paper} elevation={3}>
                            <Grid container item justifyContent="center" alignItems="center" className={classes.paging}>
                                <MsgArea data={fullTextDisplayData}/>
                            </Grid>
                        </Paper>
                    </div>
                )}
            </Grid>
        </React.Fragment>
    );
};

MessageLog.propTypes = {
    classes: PropTypes.object.isRequired,
    cookies: PropTypes.object.isRequired,
};


export default withStyles(styles)(withCookies(MessageLog));